import { render } from "./AdminCompaniesView.vue?vue&type=template&id=c6385a72"
import script from "./AdminCompaniesView.vue?vue&type=script&lang=js"
export * from "./AdminCompaniesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__